import React from 'react';

const PharmaceuticalPartner = () => {
  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <div className="flex items-center justify-between w-full bg-gray-800 text-white p-3">
        <div className="text-xl font-bold">OncoCatalyst Partner Portal</div>
        <div className="flex-1 mx-4 text-right">
          AstraZeneca Oncology
        </div>
        <div className="flex items-center">
          <div className="relative mr-3">
            <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center">
              5
            </div>
          </div>
          <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center">
            AZ
          </div>
        </div>
      </div>
      
      <div className="flex flex-1 overflow-hidden">
        <div className="w-64 bg-gray-800 text-white h-full">
          <div className="p-5 font-bold text-gray-300">NAVIGATION</div>
          <div className="flex flex-col">
            <div className="py-3 px-5 flex items-center bg-blue-600 text-white font-bold">
              <span className="mr-2">●</span>
              PARTNER DASHBOARD
            </div>
            <div className="py-3 px-5 flex items-center text-gray-300 hover:bg-gray-700">
              TRIAL MATCHING
            </div>
            <div className="py-3 px-5 flex items-center text-gray-300 hover:bg-gray-700">
              EDUCATION CONTENT
            </div>
            <div className="py-3 px-5 flex items-center text-gray-300 hover:bg-gray-700">
              RWE PROGRAMS
            </div>
            <div className="py-3 px-5 flex items-center text-gray-300 hover:bg-gray-700">
              KOL ENGAGEMENT
            </div>
            <div className="py-3 px-5 flex items-center text-gray-300 hover:bg-gray-700">
              ANALYTICS
            </div>
            <div className="py-3 px-5 flex items-center text-gray-300 hover:bg-gray-700">
              SETTINGS
            </div>
          </div>
        </div>
        
        <div className="flex-1 overflow-auto p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">Pharmaceutical Partner Dashboard</h2>
            <button className="px-4 py-2 bg-blue-500 text-white rounded">
              Export Data
            </button>
          </div>
          
          <h3 className="text-xl font-medium mb-4">Active Programs Summary</h3>
          <div className="grid grid-cols-3 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow">
              <h4 className="text-lg font-medium mb-3 text-center">Clinical Trials</h4>
              <p className="text-5xl font-bold text-blue-500 text-center mb-2">5</p>
              <p className="text-gray-600 text-center">Active trials</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h4 className="text-lg font-medium mb-3 text-center">Education Modules</h4>
              <p className="text-5xl font-bold text-purple-500 text-center mb-2">8</p>
              <p className="text-gray-600 text-center">Published modules</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h4 className="text-lg font-medium mb-3 text-center">RWE Programs</h4>
              <p className="text-5xl font-bold text-green-500 text-center mb-2">2</p>
              <p className="text-gray-600 text-center">Active studies</p>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-xl font-medium mb-4">Trial Matching Performance</h3>
              <div className="h-48 flex items-end space-x-3">
                <div className="h-32 w-12 bg-blue-400"></div>
                <div className="h-40 w-12 bg-blue-400"></div>
                <div className="h-48 w-12 bg-blue-400"></div>
                <div className="h-24 w-12 bg-blue-400"></div>
                <div className="h-36 w-12 bg-blue-400"></div>
              </div>
              <div className="flex justify-between mt-2 text-sm">
                <span>NSCLC</span>
                <span>Breast</span>
                <span>Melanoma</span>
                <span>Colorectal</span>
                <span>Lymphoma</span>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-xl font-medium mb-4">Education Engagement</h3>
              <div className="relative h-48 flex items-center justify-center">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-40 h-40 rounded-full border-16 border-purple-500 border-opacity-30"></div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-40 h-40 rounded-full border-16 border-purple-500" style={{clipPath: 'polygon(0 0, 100% 0, 100% 72%, 0% 72%)'}}></div>
                </div>
                <div className="z-10 text-center">
                  <div className="text-5xl font-bold text-gray-700">72%</div>
                  <div className="text-gray-500 text-sm">Engagement Rate</div>
                </div>
              </div>
              <div className="mt-3 text-sm">
                <div>• 1,462 physician views</div>
                <div>• 18 min avg viewing time</div>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow mb-6">
            <h3 className="text-xl font-medium mb-4">Real-World Evidence Insights</h3>
            <div className="mb-3">
              <h4 className="text-lg font-medium">Study: Treatment Patterns in Metastatic NSCLC</h4>
              <h5 className="text-base font-medium">Key Findings (Preliminary):</h5>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <ul className="list-disc pl-5 space-y-1">
                  <li>428 de-identified patient records</li>
                  <li>14 participating oncology practices</li>
                  <li>68% of patients received immunotherapy as 2nd line (up 12% YoY)</li>
                </ul>
              </div>
              <div>
                <ul className="list-disc pl-5 space-y-1">
                  <li>PD-L1 testing rate increased to 92%</li>
                  <li>Median time to treatment: 24 days</li>
                  <li>Common sequence: TKI → IO → Chemo</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="bg-gray-200 text-gray-600 text-sm p-2 border-t border-gray-300">
        Data updated: Today at 08:15 | All data de-identified | Compliant with HIPAA and GDPR
      </div>
    </div>
  );
};

export default PharmaceuticalPartner;